import {
  ComponentPropsWithoutRef,
  ElementType,
  ReactNode,
  createElement
} from 'react'

export type AsType = ElementType

export type AsProps<T extends ElementType> = {
  as: T
  children?: ReactNode
} & ComponentPropsWithoutRef<T>

export const As = <T extends React.ElementType>({
  as,
  children,
  ...props
}: AsProps<T>) => createElement(as, props, children)

export default As
